import React from 'react';
import ReactDOM from 'react-dom/client';
// Brand fonts (self-hosted @font-face): Infiniwell (brand) + Inter (UI/body).
import './common/theme/fonts.css';
import './index.css';
import App from './App';
import { AppThemeProvider } from './context/ThemeContext';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <App />
    </AppThemeProvider>
  </React.StrictMode>,
);
